import * as React from "react";
import { Jobs } from "./JobsPage";
import { JobsProvider } from "./context/JobsContext";

type Props = {};

const JobsPage = (props: Props) => {
	return (
		<JobsProvider>
			<Jobs />
		</JobsProvider>
	);
};

export default JobsPage;
